import { Component } from '@angular/core';

@Component({
  selector: 'cbs-special-operations-wrap',
  template: '<router-outlet></router-outlet>'
})

export class TermDepositSpecialOperationsWrapComponent {
}
